import { z } from 'zod';

import { PAYLOAD_FEATURES, useFeaturePayload } from '@/features/feature-flags';

export const PricingPageCopyPayloadSchema = z.object({
  plus: z
    .object({
      trialDays: z.number().int().positive().optional(),
      ctaText: z.string().min(1).optional(),
      badge: z.string().min(1).optional(),
      monthlyPrice: z.number().positive().optional(),
      annualPrice: z.number().positive().optional(),
    })
    .optional(),
  pro: z
    .object({
      discountPercent: z.number().min(0).max(100).optional(),
      badge: z.string().min(1).optional(),
    })
    .optional(),
  promoBanner: z
    .object({
      title: z.string().min(1).optional(),
      body: z.string().min(1).optional(),
    })
    .optional(),
});

export type PricingPageCopyPayload = z.infer<
  typeof PricingPageCopyPayloadSchema
>;

export function usePricingPageCopy(): PricingPageCopyPayload {
  const raw = useFeaturePayload(PAYLOAD_FEATURES.PRICING_PAGE_COPY);
  const parsed = PricingPageCopyPayloadSchema.safeParse(raw ?? {});
  return parsed.success && parsed.data ? parsed.data : {};
}
